import { render, staticRenderFns } from "./convocationInProgress.vue?vue&type=template&id=6ab44b38"
import script from "./convocationInProgress.vue?vue&type=script&lang=js"
export * from "./convocationInProgress.vue?vue&type=script&lang=js"
import style0 from "./convocationInProgress.vue?vue&type=style&index=0&id=6ab44b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports